import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {getPreorderList} from '../../service/preOrder';
import moment from 'moment';
import {getGouXiaoUnitList} from "../../service/traceOrder";

class PreOrderList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['预订单'],
            key: 0,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            searchObj: {
                flowCode: '',
                proLine: '',
                orderStatus: '',
                channelCode: this.channelData.split('|')[1] || '',
                buyCompanyName: '',
                startCreatedDate: '',
                endCreatedDate: '',
                s: 10,
                p: 1
            },
            visible: false,
            value: '',
            loading: true,
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    // /*筛选*/
    //    setFilterParam(name, value) {
    //    	this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    //    };


    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from,
                    endCreatedDate: value.end,
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                flowCode: '',
                proLine: '',
                status: '',
                buyCompanyName: '',
                startCreatedDate: '',
                endCreatedDate: '',
                p: 1,
                s: 10,
            }
        }, () => {
            self.initData();
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        var sObj = this.state.searchObj;
        this.setState({searchObj: {...this.state.searchObj, p: 1}}, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        this.setState({loading: true});
        getPreorderList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data.data || [],
                    total: result.data.total,
                    loading: false
                })
            } else {
                message.error(result.message);
            }
        })
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    addRecord(index) {
        console.log('adding ' + index);
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        // console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value
        });
    }

    handleChange() {

    }

    update = () => {
        this.goView('#/preOrder/${}');
    }

    render() {
        var self = this;
        const {opts, key, rows, total, searchObj, selectedRowKeys, visible, loading, gouxiaoUnitList} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'flowCode',
                    label: '流程编号',
                    text: '输入流程编号',
                    type: 'default',
                    defaultValue: searchObj.flowCode
                },
                {
                    name: 'proLine',
                    label: '产品线',
                    text: '选择产品线',
                    options: [
                        {value: '0', text: '全部'},
                        {value: '01', text: '元器件'},
                        {value: '02', text: '电工'},
                        {value: '03', text: '电表'},
                        {value: '04', text: '变频器'},
                        {value: '05', text: '天e'},
                        {value: '06', text: 'TG精品'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.proLine || '0'
                },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: 'N' || 'n', text: '未转正式订单'},
                        // { value: 'n', text: '未转正式订单' },
                        {value: 'Y', text: '全部转换'},
                        {value: 'E', text: '部分转换'},
                        {value: 'C', text: '已取消'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.status || ''
                },
                {
                    name: 'buyCompanyName',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    defaultValue: searchObj.buyCompanyName,
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startCreatedDate || '',
                        end: searchObj.endCreatedDate || ''
                    }
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '预订单编号',
                    dataIndex: 'headerId'
                },
                {
                    title: '流程编号',
                    dataIndex: 'flowCode'
                },
                {
                    title: '请求日期',
                    dataIndex: 'createdDate',
                    render: (text, record, index) => {
                        return moment(parseInt(text)).format('YYYY-MM-DD')
                    }
                },
                {
                    title: '购货单位',
                    dataIndex: 'buyCompanyName'
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    /*                render: (text, record, index) => {
                                      if (text === '01') return '元器件';
                                     if (text === '02') return '电工';
                                     if (text === '03') return '电表';
                                     if (text === '04') return '变频器';
                                     if (text === '05') return '天e';
                                     if (text === '06') return 'TG精品';
                                     return '';
                                   }
               */
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName',
                    //   render: (text, record, index) => {
                    //     if (text === 'N') return '未转正式订单';
                    //     if (text === 'Y') return '全部转换';
                    //     if (text === 'E') return '部分转换';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     if (text === 'C') return '已取消';
                    //     return '';
                    // }
                },
                {
                    title: '预订单状态',
                    dataIndex: 'status',
                    /*render: (text, record, index) => {
                       if (text === 'N'|| text === 'n') return '未转正式订单';
                      if (text === 'Y') return '全部转换';
                      if (text === 'E') return '部分转换';
                      if (text === 'C') return '已取消';
                      return '';
                    }*/
                },
                {
                    title: '更新',
                    dataIndex: 'action',
                    render: (text, record, index) => {
                        // console.log(record.headerId);
                        // debugger
                        return (
                            <a href={`#/preOrder/${record.headerId}&${record.status}`} /*style={{display: (record.status == '已取消' ||  record.status == '全部转换') ? 'none' : 'block'}}*/>更新</a>
                        )
                    }
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <TableView {...tableViewProps}/>
            </div>

            <Modal
                visible={visible}
                title="入库"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={800}
            >
                <div>
                    <Row>
                        <Col>
                            <label className="ant-form-item-required">是否增加库存：</label>
                            <Radio.Group onChange={self.onChange} value={this.state.value}>
                                <Radio value={'Y'}>是</Radio>
                                <Radio value={'N'}>否</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 10}}>
                        <Col>
                            <label>子库存：</label>
                            <Select defaultValue="jack" style={{width: 120}} onChange={self.handleChange}>
                                <Select.Option value="jack">电力01库</Select.Option>
                                <Select.Option value="lucy">电力02库</Select.Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 10}}>
                        <Col>
                            <label className="ant-form-item-required">验证码：</label>
                            <Input style={{width: 65}} maxLength='6'/>
                            <Button style={{marginLeft: 10}}>获取验证码</Button>
                            <span style={{
                                fontSize: 'xx-small',
                                display: 'none'
                            }}>已向授权收货人xxasdasdasdasdasdasdasdasdasdasdasdasdasd手机：13888888888发送短信</span>
                        </Col>
                    </Row>
                </div>
            </Modal>


        </div>
    }
}
;
export default withRouter(PreOrderList);


// WEBPACK FOOTER //
// ./src/routes/preOrder/list.js